import { t } from "i18next"
import { WatchState } from "../model/InstructionalVideoDtos"

export const useWatchStates = () => {
    const watchStates = [
        { text: t("NotWatched"), value: WatchState.Not },
        { text: t("PartiallyWatched"), value: WatchState.Partially },
        { text: t("FullyWatched"), value: WatchState.Fully },
    ]

    const watchStatesLookup = {
        dataSource: {
            store: {
                type: 'array',
                data: watchStates,
                key: 'value',
            },
        },
        valueExpr: "value",
        displayExpr: "text",
    }

    return { watchStates, watchStatesLookup }
}
